import { DatePicker } from "rsuite";
import useDateObject from "./useDateObject";

const DateTimeInput = ({
  inputSize,
  field,
  onChange,
  value,
  disabled = false,
  setIsOpen,
  isRecord = false,
}) => {
  const { dateValue, setDateValue } = useDateObject(value, "MM-DD-YYYYTHH:mm");

  return (
    <DatePicker
      id={isRecord ? undefined : `record-input-${field.APIName}`}
      onOpen={updateOpen(true)}
      onClose={updateOpen(false)}
      placement="autoVerticalStart"
      format={"MM-dd-yyyy HH:mm"}
      placeholder="MM-DD-YYYY HH:MM"
      value={dateValue}
      onSelect={handleChange}
      size={inputSize}
      disabled={disabled}
      block
      preventOverflow
      onClean={() => handleChange(null)}
      cleanable={!field?.Required}
      // oneTap // Enabling "oneTap" property results in strange behaviour
    />
  );

  function handleChange(newDateTime) {
    onChange(newDateTime);
    setDateValue(newDateTime);
  }

  // This allows the parent to know when this component is open.
  function updateOpen(open) {
    if (typeof setIsOpen !== "function") return null;

    return () => setIsOpen(open);
  }
};

export default DateTimeInput;
